import { render, staticRenderFns } from "./RLVEvidenceResults.vue?vue&type=template&id=9f8916e4&scoped=true"
import script from "./RLVEvidenceResults.vue?vue&type=script&lang=js"
export * from "./RLVEvidenceResults.vue?vue&type=script&lang=js"
import style0 from "./RLVEvidenceResults.vue?vue&type=style&index=0&id=9f8916e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8916e4",
  null
  
)

export default component.exports